import React, { Component } from "react";
import PropTypes from 'prop-types';
import { Row, Col } from 'react-bootstrap';
import { connect } from 'react-redux';

import { getS3Object } from '../utils/myKadImg';
import * as selectors from '../redux/selectors';
import { authenticateCurrentUser } from '../redux/authenticate/actions';
import { getSuspiciousProfileList } from '../redux/suspiciousProfiles/actions';
import * as userStatus from '../redux/users/status'; 
import { verifySuspiciousProfile } from '../redux/suspiciousProfiles/actions';
import * as verifyStatus from '../redux/suspiciousProfiles/status'; 
import { flashMessage } from '../redux/flash/actions';
import { sendReportEmail } from '../redux/email/actions';
import * as emailStatus from '../redux/email/status';
import * as singleCheckStatus from '../redux/singleCheck/status';
import { getSingleCheck } from '../redux/singleCheck/actions';

import Value from '../components/Value';
import Image from '../components/Image';
import ListCollapse from '../components/ListCollapse';
import Date from '../components/Date';
import Identity from '../components/Identity';
import Modal from '../components/Modal';
import GetSingle from '../components/GetSingle';

import loading from '../assets/logos/logo-spin.svg';
import loadSuccess from '../assets/icons/ico-tick-green-round.svg';

import './ListItems.css';

class SuspiciousUserListItems extends Component {
  static propTypes = {
    suspiciousProfile: PropTypes.oneOfType([
      PropTypes.array,
      PropTypes.object,
    ]),
    loading: PropTypes.bool,
    reveal: PropTypes.string,
  
  }
  static defaultProps = {
    loading: false,
    reveal: '',
  }

  static contextTypes = {
    store: PropTypes.object,
  }

  static mapStateToProps = state => ({
    loading: selectors.getSuspiciousVerificationLoading(state),
  });

  constructor(props) {
    super(props);
    this.state = {
      reveal: props.reveal,
      key: 1,
      images: [],
      showModal: false,
      showEmailModal: false,
      showEmailBtn: false,
      showLoadModal: false,
      loadModalText: '',
    };
  }

  async componentDidMount() {
    await this.loadImages();
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.reveal !== this.props.reveal) {
      this.setState({ reveal: nextProps.reveal });
    }
    if (this.props.suspiciousProfile ||
      this.props.suspiciousProfile.suspicious.icFront !== nextProps.suspiciousProfile.suspicious.icFront ||
      this.props.suspiciousProfile.suspicious.icBack !== nextProps.suspiciousProfile.suspicious.icBack ||
      this.props.suspiciousProfile.genuine.icFront !== nextProps.suspiciousProfile.genuine.icFront ||
      this.props.suspiciousProfile.genuine.icBack !== nextProps.suspiciousProfile.genuine.icBack
    ) {
      this.loadImages();
    }
  }

  componentWillUnmount() {
    this.loadImages();
    this.clearTimer();
  }

  setStateAsync(state) {
    return new Promise((resolve) => {
      this.setState(state, resolve);
    });
  }

  async loadImages() {
    await this.setStateAsync({ loadingImages: true });
    const { store } = this.context;
    const { suspiciousProfile } = this.props;
    const token = await store.dispatch(authenticateCurrentUser());
    let images;
    try {
      const runImages = [];
      suspiciousProfile.forEach((obj, idx) => {
        if (obj.suspicious.icFront) {
          runImages.push(getS3Object(obj.suspicious.icFront, 'icFront', token));
        }
        if (obj.suspicious.icBack) {
          runImages.push(getS3Object(obj.suspicious.icBack, 'icBack', token));
        }
        if (obj.genuine.icFront) {
          runImages.push(getS3Object(obj.genuine.icFront, 'icFront', token));
        }
        if (obj.genuine.icBack) {
          runImages.push(getS3Object(obj.genuine.icBack, 'icBack', token));
        }
      });
      images = await Promise.all(runImages);
    } catch (e) {
      return;
    }
    await this.setStateAsync({
      images,
      loadingImages: false,
    });
  }

  getReveal = () => {
    this.props.onReveal(this.state.reveal);
  }

  toggleShow = (i) => {
    this.setState({
      reveal: this.state.reveal === i ? null : i
    }, () => {
      this.getReveal();
    });
  }


  handleOpenModal = (obj) => {
    this.setState({
      showVerifyModal: this.state.showVerifyModal === obj ? null : obj,
    });
  }
  
  handleCloseModal = (event) => {
    event.preventDefault();
    this.setState({ 
      showModal: false,
      showVerifyModal: false,
      showLoadModal: false,
    });
  }
  
  handleVerify = async (genuine, suspicious) => {
    const { store } = this.context;
    const body = {
      genuine: {
        userID: genuine.userID,
        profileID: genuine.profileID,
      },
      suspicious: {
        userID: suspicious.userID,
        profileID: suspicious.profileID,
      },
    };
    
    await this.setStateAsync({
      showVerifyModal: false,
      showLoadModal: this.state.showLoadModal === suspicious.profileID ? null : suspicious.profileID,
      loadModalImg: loading,
      loadModalText: 'Verifying...'
    });
    const res =  await store.dispatch(verifySuspiciousProfile(body));
    if (res > verifyStatus.VERIFYSUSPICIOUSUSER_STATUS_OK) {
      await this.setStateAsync({ showLoadModal: false });
      await store.dispatch(flashMessage('Error in verifying the user.', 'error'));
      return;
    }
    await store.dispatch(flashMessage('User verification success.', 'notify'));
    this.setStateAsync({
      loadModalText: 'Sending result...',
    });

    this.timer = setTimeout(() => {
      this.ReportEmail(suspicious);
    }, 10000);
  }

  getCheck = async (user) => {
    const { store } = this.context;
    const body = {
      userID: user.userID,
      checkID: user.checkID,
    };

    this.setState({
      userID: user.userID,
      checkID: user.checkID,
    });

    const res = await store.dispatch(getSingleCheck(body));
    if (res > singleCheckStatus.SINGLECHECK_STATUS_OK || user.status !== 'request_success') {
      await store.dispatch(flashMessage(`Fail to send email to ${user.email} due to user check issue`, 'error'));
      return;
    }
    await this.ReportEmail(user);
  }

  ReportEmail = async (user) => {
    const { store } = this.context;
    const body = {
      userID: user.userID,
      checkID: user.checkID,
      profileID: user.profileID,
    };
    const res = await store.dispatch(sendReportEmail(body));
    if (res === emailStatus.EMAIL_STATUS_OK) {
      await this.setStateAsync({ loadModalImg: loadSuccess, loadModalText: 'Result Sent' });
      await store.dispatch(flashMessage(`Send email to ${user.email} success`, 'notify'));
      await this.updateList();
      return;
    }
    await this.setStateAsync({
      showLoadModal: false,
      loadModalImg: null,
      loadModalText: '',
    });
    await this.getCheck(user);
  }

  updateList = async () => {
    const { store } = this.context;
    this.timer = setTimeout(() => {
      this.setState({
        showLoadModal: false,
        loadModalImg: null,
        loadModalText: '',
      });
    }, 2000);
    const updateRes =  await store.dispatch(getSuspiciousProfileList());
    if (updateRes > userStatus.USER_STATUS_OK) {
      store.dispatch(flashMessage('Error update user details. Please manually refresh to view updated details.', 'error'));
      return;
    }
  }

  clearTimer = () => {
    clearTimeout(this.timer);
  }

  renderModal = (obj) => {
    const { showVerifyModal, showLoadModal, loadModalText, loadModalImg } = this.state;
    return (
      <span>
        <Modal
        className="rowModal"
          close={showVerifyModal === obj.suspicious.profileID}
          customButtons={
            <div className="modal-buttons">
              <button id="verifyAndEmail" onClick={() => this.handleVerify(obj.genuine, obj.suspicious)}>
                Verify and Email Result
              </button>
              <button onClick={this.handleCloseModal}>Cancel</button>
            </div>
          }
        >
          Are you sure you want to verify and email result to <br /> {obj.suspicious.email}?
        </Modal> 
        
        <Modal className="rowModal" close={showLoadModal === obj.suspicious.profileID}>
          <img className="modal-img" src={loadModalImg} alt="load" />
          <p>{loadModalText}</p>
        </Modal> 
      </span> 
    );
  }

  render() {
    return (
      <div className="ListItems">
        {
          [].concat(this.props.suspiciousProfile).map((obj, i) => {
            const uploadedICFront = this.state.images.find(i => i.key === obj.suspicious.icFront && i.name === 'icFront');
            const uploadedICBack = this.state.images.find(i => i.key === obj.suspicious.icBack && i.name === 'icBack');
            const uploadedGenuineICFront = this.state.images.find(i => i.key === obj.genuine.icFront && i.name === 'icFront');
            const uploadedGenuineICBack = this.state.images.find(i => i.key === obj.genuine.icBack && i.name === 'icBack');
            return (
              <Row key={i}>
                {this.renderModal(obj)}  

              <Row className="row-eq-height">
                <Col className="indexCol">{i+1}</Col>
                <Col className="createdAt">
                  <GetSingle type="check" object={obj}>
                    <Date>{obj && obj.suspicious.lastUpdated}</Date>
                  </GetSingle>
                </Col>
                <Col xs={3}>
                  <GetSingle type="profile" object={obj.suspicious}>
                    {obj.suspicious.name}
                  </GetSingle> <br />
                  <code>{obj.suspicious.email}</code>
                </Col>
                <Col className="actionCol">
                  <button className="buttonLink" onClick={() => this.toggleShow(obj.suspicious.profileID)}>
                    {this.state.reveal === obj.suspicious.profileID ? 'Hide Details' : `View More Details`}
                  </button>
                  <a className="buttonLink" href={`mailto:${obj.email}?Subject=[DSR-PG]`} target="_top">
                    Contact User
                  </a>
                </Col>
              </Row>
              <ListCollapse reveal={this.state.reveal === obj.suspicious.profileID}>
                <span className="table">
                  <Row className="titleRow">
                    <Col xs={1}><h4>Details</h4></Col>
                    <Col xs={5}><h4>Suspicious User</h4></Col>
                    <Col xs={5}><h4>Verified User</h4></Col>
                  </Row>
                  <Row>
                    <Col xs={1}>MyKad</Col>
                    <Col xs={5} className="flexCol">
                      {
                        obj && uploadedICFront ?
                        <Image
                          src={uploadedICFront ? uploadedICFront.body : null}
                          alt="IC Front"
                          loading={this.state.loadingImages}
                          fullWidth
                        />
                        : <span>No Upload IC Front</span>
                      }
                      {
                        obj && uploadedICBack ?
                        <Image
                          src={uploadedICBack ? uploadedICBack.body : null}
                          alt="IC Back"
                          loading={this.state.loadingImages}
                          fullWidth
                          />
                        : <span>No Upload IC Back</span>
                      }
                    </Col>
                    <Col xs={5} className="flexCol">
                      {
                        obj && uploadedGenuineICFront ?
                        <Image
                          src={uploadedGenuineICFront ? uploadedGenuineICFront.body : null}
                          alt="IC Front"
                          loading={this.state.loadingImages}
                          fullWidth
                        />
                        : 'No Upload IC Front'
                      }
                      {
                        obj && uploadedGenuineICBack ?
                        <Image
                          src={uploadedGenuineICBack ? uploadedGenuineICBack.body : null}
                          alt="IC Back"
                          loading={this.state.loadingImages}
                          fullWidth
                          />
                        : 'No Upload IC Back'
                      }
                    </Col>
                  </Row>
                  <Row>
                    <Col xs={1}>MyKad No.</Col>
                    <Col xs={5}><Identity type={1} identity={`${obj.suspicious.nric}`} /></Col>
                    <Col xs={5}><Identity type={1} identity={`${obj.genuine.nric}`} /></Col>
                  </Row>
                  <Row>
                    <Col xs={1}>Name</Col>
                    <Col xs={5}>{obj.suspicious.name}</Col>
                    <Col xs={5}>{obj.genuine.name}</Col>
                  </Row>
                  <Row>
                    <Col xs={1}>Email</Col>
                    <Col xs={5}>{obj.suspicious.email}</Col>
                    <Col xs={5}>{obj.genuine.email}</Col>
                  </Row>
                  <Row>
                    <Col xs={1}>Mobile</Col>
                    <Col xs={5}>{obj.suspicious.mobile}</Col>
                    <Col xs={5}>{obj.genuine.mobile}</Col>
                  </Row>
                  <Row>
                    <Col xs={1}>Income</Col>
                    <Col xs={5}><Value money>{obj.suspicious.incomeNetCents}</Value></Col>
                    <Col xs={5}><Value money>{obj.genuine.incomeNetCents}</Value></Col>
                  </Row>
                  <Row>  
                    <Col xs={1}>Created At</Col>
                    <Col xs={5}><Value><Date>{obj.suspicious.createdAt}</Date></Value></Col>
                    <Col xs={5}><Value><Date>{obj.genuine.createdAt}</Date></Value></Col>
                  </Row>
                  <Row>
                    <Col xs={1}>Action</Col>
                    <Col xs={5}>

                    <button
                      className="Button primary"
                      onClick={() => this.handleOpenModal(obj.suspicious.profileID)}
                    >
                      Verify User
                    </button>
                    </Col>
                  </Row>  
                </span>  
              </ListCollapse>
            </Row>
            );
            }
          )
        }
      </div>
    );
  }
}

export default connect(SuspiciousUserListItems.mapStateToProps)(SuspiciousUserListItems);



// WEBPACK FOOTER //
// ./src/components/SuspiciousUserListItems.jsx